import { render, staticRenderFns } from "./logics.vue?vue&type=template&id=5210e523"
import script from "./logics.vue?vue&type=script&lang=js"
export * from "./logics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports